import React, { useEffect, useState } from "react";
 
const ShelfPictorialView = () => {
  const [inventoryData, setInventoryData] = useState([]);
  const [selectedPharmacy, setSelectedPharmacy] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchInventoryData = async () => {
      const groupId = localStorage.getItem("userId");
      if (!groupId) return;

      try {
 const token = localStorage.getItem("authToken");
const response = await fetch(
  `https://api.pharmacegroup.co.uk/ggetInventory?groupId=${groupId}`,
  {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
);
       let data = await response.json();
        data = data.filter(
          (item) =>
            !item.pharmacyName?.startsWith("Warehouse") &&
            (item.status || "").trim() === "On shelf"
        );
        setInventoryData(data);

        if (!selectedPharmacy && data.length > 0) {
          setSelectedPharmacy(data[0].pharmacyName);
        }
      } catch (err) {
        console.error("Failed to fetch data:", err);
      }
    };

    fetchInventoryData();
  }, [selectedPharmacy]);

  const getWeeksUntil = (dateStr) => {
    if (!dateStr) return "";
    const now = new Date();
    const target = new Date(dateStr);
    const diffMs = target - now;
    return Math.floor(diffMs / (1000 * 60 * 60 * 24 * 7));
  };

  const getWeeksSince = (dateStr) => {
    if (!dateStr) return "";
    const now = new Date();
    const target = new Date(dateStr);
    const diffMs = now - target;
    return Math.floor(diffMs / (1000 * 60 * 60 * 24 * 7));
  };

  const getExpiryColor = (weeksUntil) => {
    if (weeksUntil < -500) return "white";
    const clamped = Math.max(0, Math.min(12, weeksUntil));
    const ratio = clamped / 12;
    const r = Math.round(255 * (1 - ratio));
    const g = Math.round(200 * ratio);
    return `rgb(${r}, ${g}, 0)`;
  };

  const shelfChecks = JSON.parse(localStorage.getItem("shelf_checks") || "[]");
  const members = JSON.parse(localStorage.getItem("members") || "[]");
  const matched = members.find((m) => m.pharmacyName === selectedPharmacy);
  const pharmacyId = matched ? matched.pharmacyId : "";

  let filteredShelves = shelfChecks;
  if (selectedPharmacy) {
    filteredShelves = shelfChecks.filter((shelf) => shelf.pharmacyId === pharmacyId);
  }

  const locationList = [...new Set(filteredShelves.map((shelf) => shelf.description))].sort();
  const pharmacyList = [...new Set(inventoryData.map((item) => item.pharmacyName))];

  const getLocationSummary = (location) => {
    let items = inventoryData.filter((item) => {
      const itemLocation = (item.location?.trim().toLowerCase() || "unknown");
      const targetLocation = location.trim().toLowerCase();
      const nameMatch = item.pharmacyName === selectedPharmacy;

      const match = nameMatch && itemLocation === targetLocation;

      // 🔎 Debug log to see why a location might be skipped
      if (!match && nameMatch) {
        console.log(`⚖️ Location mismatch for item:`, {
          itemLocation: itemLocation,
          targetLocation: targetLocation,
          originalItemLocation: item.location,
          originalTargetLocation: location
        });
      }

      return match;
    });

    if (searchTerm.trim()) {
      const term = searchTerm.toLowerCase();
      items = items.filter((item) => (item.vmppNm || "").toLowerCase().includes(term));
    }

    items.sort((a, b) => {
      const nameA = (a.vmppNm || "").toLowerCase();
      const nameB = (b.vmppNm || "").toLowerCase();
      return nameA.localeCompare(nameB);
    });

    const totalPackets = items.reduce((sum, i) => sum + (parseInt(i.balance || 0)), 0);
    const uniqueDrugs = new Set(items.map((i) => i.vmppNm)).size;
    const totalValue = items.reduce((sum, i) => sum + (i.price || 0), 0);

    return { totalPackets, uniqueDrugs, totalValue, items };
  };

  return (
    <div style={{ padding: "20px" }}>
      <h1>Shelf contents - pictorial view</h1>

      <div style={{ marginBottom: "20px" }}>
        <label>Pharmacy: </label>
        <select value={selectedPharmacy} onChange={(e) => setSelectedPharmacy(e.target.value)}>
          {pharmacyList.map((ph, i) => (
            <option key={i} value={ph}>
              {ph}
            </option>
          ))}
        </select>
        <input
          type="text"
          placeholder="Search drug..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ marginLeft: "20px", padding: "4px" }}
        />
      </div>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
        {locationList.map((location, index) => {
          const summary = getLocationSummary(location);
          return (
            <div
              key={index}
              style={{
                border: "1px solid black",
                padding: "10px",
                width: "300px",
                height: "300px",
                overflow: "hidden",
                borderRadius: "8px",
                backgroundColor: "#f8f8f8",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <h2 style={{ margin: "0 0 5px 0", fontSize: "18px" }}>{location}</h2>
              <div style={{ marginBottom: "6px", lineHeight: "1.2", fontSize: "12px" }}>
                <div>Total items: {summary.totalPackets}</div>
                <div>Different drugs: {summary.uniqueDrugs}</div>
                <div>Total value: £{(summary.totalValue / 100).toFixed(2)}</div>
              </div>
              <div style={{ flexGrow: 1, overflowY: "auto", marginTop: "5px", fontSize: "11px" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      <th style={{ textAlign: "left" }}>Drug</th>
                      <th style={{ textAlign: "left" }}>£</th>
                      <th>⇠</th>
                    </tr>
                  </thead>
                  <tbody>
                    {summary.items.map((item, i) => {
                      const weeksUntil = getWeeksUntil(item.expiryDate);
                      return (
                        <tr key={i} style={{ backgroundColor: getExpiryColor(weeksUntil) }}>
                          <td>{item.vmppNm}</td>
                          <td>{(item.price / 100).toFixed(2)}</td>
                          <td>{getWeeksSince(item.firstScanned)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ShelfPictorialView;
